"use client";
import {
  AppSnackbarError,
  AppSnackbarSuccess,
  AppSnackbarWarning,
} from "@/common";
import theme from "@/material";
import { ISession } from "@/models";
import { AppStore, makeStore } from "@/redux-store";
import { authActions } from "@/redux-store/auth.slice";
import { CssBaseline, GlobalStyles, ThemeProvider } from "@mui/material";
import { AppRouterCacheProvider } from "@mui/material-nextjs/v14-appRouter";
import { setupListeners } from "@reduxjs/toolkit/query";
import { SnackbarProvider } from "notistack";
import { useEffect, useRef } from "react";
import { Provider } from "react-redux";
import { SESSION_REFRESHED_EVENT } from "@/apiRequester/http";

const AppProvider = ({
  children,
  initialSession,
}: {
  children: React.ReactNode;
  initialSession?: ISession | null;
}) => {
  // const [{ cache, flush }] = useState(() => {
  //   const cache = createEmotionCache();
  //   cache.compat = true;
  //   const prevInsert = cache.insert;
  //   let inserted: string[] = [];
  //   cache.insert = (...args) => {
  //     const serialized = args[1];
  //     if (cache.inserted[serialized.name] === undefined) {
  //       inserted.push(serialized.name);
  //     }
  //     return prevInsert(...args);
  //   };
  //   const flush = () => {
  //     const prevInserted = inserted;
  //     inserted = [];
  //     return prevInserted;
  //   };
  //   return { cache, flush };
  // });

  // useServerInsertedHTML(() => {
  //   const names = flush();
  //   if (names.length === 0) {
  //     return null;
  //   }
  //   let styles = "";
  //   for (const name of names) {
  //     styles += cache.inserted[name];
  //   }
  //   return (
  //     <style
  //       key={cache.key}
  //       data-emotion={`${cache.key} ${names.join(" ")}`}
  //       dangerouslySetInnerHTML={{
  //         __html: `${styles}
  //         `,
  //       }}
  //     />
  //   );
  // });
  const storeRef = useRef<AppStore>();
  if (!storeRef.current) {
    // Create the store instance the first time this renders
    storeRef.current = makeStore();
  }

  useEffect(() => {
    storeRef.current?.dispatch(authActions.setSession(initialSession ?? undefined));
  }, [initialSession]);

  useEffect(() => {
    if (storeRef.current) {
      const handleSessionRefreshed = (event: Event) => {
        const customEvent = event as CustomEvent<ISession>;
        storeRef.current?.dispatch(
          authActions.setSession(customEvent.detail ?? undefined),
        );
      };
      window.addEventListener(SESSION_REFRESHED_EVENT, handleSessionRefreshed);
      // configure listeners using the provided defaults
      // optional, but required for `refetchOnFocus`/`refetchOnReconnect` behaviors
      const unsubscribe = setupListeners(storeRef.current.dispatch);
      return () => {
        window.removeEventListener(
          SESSION_REFRESHED_EVENT,
          handleSessionRefreshed,
        );
        unsubscribe();
      };
    }
  }, []);

  return (
    <Provider store={storeRef.current}>
      <AppRouterCacheProvider
        options={{ key: "muicss", enableCssLayer: true, prepend: true }}
      >
        {/* <CacheProvider value={cache}> */}
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <GlobalStyles
            styles={{
              "*, :before, :after": {
                boxSizing: "border-box",
                border: "0 solid #e5e7eb", // Thêm !important nếu cần
              },
            }}
          />
          <SnackbarProvider
            maxSnack={4}
            anchorOrigin={{
              horizontal: "right",
              vertical: "bottom",
            }}
            TransitionProps={{
              direction: "left",
            }}
            Components={{
              ErrorServer: AppSnackbarError,
              WarningNotify: AppSnackbarWarning,
              SucceedNotify: AppSnackbarSuccess,
            }}
          >
            <main>{children}</main>
          </SnackbarProvider>
        </ThemeProvider>
        {/* </CacheProvider> */}
      </AppRouterCacheProvider>
    </Provider>
  );
};

export default AppProvider;
